export default __webpack_public_path__ + "static/media/white_unicorn.5cd56d4b.png";